import { Breadcrumb, Popover } from "antd";
import { Link } from "react-router-dom";
import { getUrlWithLocal } from "../../utils/getUrlWithLocal";
import { Print_Icon, Share_Icon } from "../../assets/images";
import React from "react";
import "../../assets/styles/components/details-header.scss"
import {
    FacebookIcon,
    FacebookShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    TwitterIcon,
    TwitterShareButton
} from "react-share";
import {PROJECT_LINK} from "../../constants/constants";

export function DetailsHeader (props) {
    const { staticTexts, breadCrumbList, onPrint, contact,houseId,params } = props

    const content = houseId ? (
        <div className={'social-media'}>
            <FacebookShareButton url={`${PROJECT_LINK.url}${getUrlWithLocal(`/floor/${params?.num}/place/${houseId}`)}`} quote={"ParkRoyal"}>
                <p><FacebookIcon size={18} round={true}/> Facebook</p>
            </FacebookShareButton>
            <TwitterShareButton url={`${PROJECT_LINK.url}${getUrlWithLocal(`/floor/${params?.num}/place/${houseId}`)}`} title={'ParkRoyal'}>
                <p><TwitterIcon size={18} round={true}/> Twitter</p>
            </TwitterShareButton>
            <LinkedinShareButton url={`${PROJECT_LINK.url}${getUrlWithLocal(`/floor/${params?.num}/place/${houseId}`)}`} title={'ParkRoyal'} description={'ParkRoyal'}>
                <p><LinkedinIcon size={18} round={true}/> Linkedin</p>
            </LinkedinShareButton>
        </div>
    ) : (
        <div className={'social-media'}>
            <FacebookShareButton url={PROJECT_LINK.url} quote={"ParkRoyal"}>
                <p><FacebookIcon size={18} round={true}/> Facebook</p>
            </FacebookShareButton>
            <TwitterShareButton url={PROJECT_LINK.url} title={'ParkRoyal'}>
                <p><TwitterIcon size={18} round={true}/> Twitter</p>
            </TwitterShareButton>
            <LinkedinShareButton url={PROJECT_LINK.url} title={'ParkRoyal'} description={'ParkRoyal'}>
                <p><LinkedinIcon size={18} round={true}/> Linkedin</p>
            </LinkedinShareButton>
        </div>
    )

    return <div className={'DistributeWrapper'}>
        <div className={'floor-breadcrumb-wrapper'}>
            <Breadcrumb>
                {breadCrumbList.map((item, index) => {
                    return <Breadcrumb.Item key={index}>
                        {item?.url ? <Link
                            to={getUrlWithLocal(item?.url)}>
                            {item.title}
                        </Link> : item.title}
                    </Breadcrumb.Item>
                })}
            </Breadcrumb>
        </div>
        <div className={'share-block'}>
            <div className={'share'}>
                <Popover content={content} trigger="click" placement="bottom">
                    <Share_Icon/>
                    <span className={'share-title'}>{staticTexts?.share_title}</span>
                </Popover>
            </div>
            {onPrint && <><div className={'divider'}/>
                <div className={'print'} onClick={onPrint}>
                <Print_Icon/> <span>{staticTexts?.print_title}</span>
                </div></>}
        </div>
    </div>
}
